import { render, staticRenderFns } from "./Checkongkir.vue?vue&type=template&id=3ea1a011&"
import script from "./Checkongkir.vue?vue&type=script&lang=js&"
export * from "./Checkongkir.vue?vue&type=script&lang=js&"
import style0 from "./Checkongkir.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports